export default __webpack_public_path__ + "static/media/stock3.11aa450a.jpg";